var map = {
	"./back.svg": "972b",
	"./beijing.svg": "6144",
	"./change.svg": "1a94",
	"./close.svg": "864a",
	"./collected.svg": "4d2a",
	"./collection.svg": "55c9d",
	"./company.svg": "5cd5",
	"./enterprise-blue.svg": "e27c",
	"./enterprise-cyan.svg": "b910",
	"./enterprise-logo-blue.svg": "0f2c",
	"./enterprise-logo-cyan.svg": "63ca",
	"./enterprise-logo-violet.svg": "0a1a",
	"./enterprise-logo-yellow.svg": "fe1b",
	"./enterprise-violet.svg": "87ed",
	"./enterprise-yellow.svg": "864d",
	"./gx-cancel.svg": "7cc7",
	"./gx-cover.svg": "49df",
	"./gx-evaluation.svg": "3c45",
	"./gx-null.svg": "7b67",
	"./gx-search.svg": "c438",
	"./gx_1.svg": "6108",
	"./gx_2.svg": "8abd",
	"./gxbg-cover.svg": "e435",
	"./hainan.svg": "7c6c",
	"./handoff.svg": "7304",
	"./logo.svg": "d9b6",
	"./report.svg": "022e",
	"./right.svg": "6ffa",
	"./search.svg": "679a",
	"./search1.svg": "8d86",
	"./search_blue.svg": "5555",
	"./share-btn.svg": "e319",
	"./share.svg": "2296",
	"./shouqi.svg": "0f16",
	"./time.svg": "f8e6",
	"./zhankai.svg": "9651",
	"./zjtx_1.svg": "d976",
	"./zjtx_2.svg": "e600",
	"./zjtx_3.svg": "0115",
	"./zjtx_4.svg": "3386",
	"./zjtx_5.svg": "1dd6",
	"./zjtx_6.svg": "c411",
	"./zjtx_text.svg": "445e",
	"./zjtxh5_1.svg": "ff3d",
	"./zjtxh5_2.svg": "e81a",
	"./zjtxh5_3.svg": "b0e3",
	"./zjtxh5_4.svg": "5344",
	"./zjtxh5_5.svg": "53d9",
	"./zjtxh5_6.svg": "f30b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";